import React, {useState, useEffect, useRef} from "react"
import {SketchPicker} from "react-color"
import cx from "classnames"
import {useAutoPopoverPosition} from "./useAutoPopoverPosition"
import styles from "./BaseColorPicker.module.css"

type Props = {
    value: string
    onChange?: (color: string) => void
    popoverClass?: string
}

export function TableColorPicker(props: Props) {
    const [isShow, setIsShow] = useState(false)
    const [color, setColor] = useState("#fff")
    const swatchRef = useRef<HTMLDivElement>(null)
    const {value, onChange, popoverClass} = props
    const {style: popoverStyle, updatePosition} = useAutoPopoverPosition({
        isOpen: isShow,
        anchorRef: swatchRef
    })

    useEffect(() => {
        setColor(value)
    }, [value])

    const toggleShowColorPicker = () => {
        if (!isShow) {
            updatePosition()
            setIsShow(true)
            return
        }
        setIsShow(false)
    }

    const onClose = () => {
        setIsShow(false)
    }

    const onChangeColor = (nextColor) => {
        const newColor = nextColor.hex
        setColor(newColor)
        if (onChange) {
            onChange(newColor)
        }
    }

    return (
        <div className={styles.wrapper}>
            <div ref={swatchRef} className={styles.swatch} onClick={toggleShowColorPicker}>
                <div className={styles.color} style={{background: color}} />
            </div>
            {isShow && (
                <div className={cx(styles.popover, popoverClass)} style={popoverStyle}>
                    <div className={styles.cover} onClick={onClose} />
                    <SketchPicker color={color} onChange={onChangeColor} disableAlpha />
                </div>
            )}
        </div>
    )
}
